<template>
  <div v-on:click="openDorm()"
    class="dorm-card"
    :class="[{
        premium : dorm.is_advert,
        male : dorm.dorm_type_id === 1,
        female : dorm.dorm_type_id === 2
      }]">
    <div class="dorm-card__top">
      <!--"dorm-card-badge" elementi sadece dorm 1. sıra sabit reklamı var ise görünür.-->
      <div class="dorm-card-badge" v-if="dorm.is_advert">

        <div class="badge_in">
          <div class="img_wrp">
            <img src="@/assets/img/star-icon-white.svg" alt="" class="img-fluid">
          </div>
          <span>Popüler</span>
        </div>

        <!-- <div class="button red icon-left" :class="[{
        premium : dorm.is_advert,
        male : dorm.dorm_type_id === 1,
        female : dorm.dorm_type_id === 2
      }]">
          <span class="button__wrp">
            <span class="button__icon">

              <img src="@/assets/img/star-icon-white.svg" alt="" class="img-fluid" width="20">

            </span>
            <span class="button__txt">
                Popüler Tercih
            </span>
          </span>
        </div> -->
      </div>
      <img :src="dorm.cover ? dorm.cover : require('@/assets/img/yurtlarburada-default.jpg')" alt="" class="dorm-card__img">
      <div class="dorm-card__overlay">

      <v-button
        class="dorm-card__button"
        title="İncele"
      />
      </div>
    </div>
    <div class="dorm-card__cnt">
      <div class="dorm-card__content">
        <div class="dorm-card__title">
          <small v-if="!dorm.branch_count || !dorm.center_slug">{{ dorm.city.name }}, {{ dorm.district.name }}</small>
          <small v-if="dorm.branch_count > 0 && dorm.center_slug">{{ distinctCities }}</small>
          <span class="dorm-card__title-main" :title="dorm.name" v-if="!dorm.branch_count || !dorm.center_slug">
            {{ dorm.name }}
          </span>
          <span class="dorm-card__title-main" :title="dorm.center_name" v-if="dorm.branch_count > 0 && dorm.center_slug">
            {{ dorm.center_name }}
          </span>
        </div>
        <!--<div class="dorm-card-price">-->
        <!--<div class="dorm-card-price__title">-->
        <!--{{ dorm.price }} TL-->
        <!--</div>-->
        <!--<div class="dorm-card-price__txt">-->
        <!--‘den başlayan<br>oda fiyatları-->
        <!--</div>-->
        <!--</div>-->
      </div>
      <div class="dorm-card__bottom">
        <div class="show-tel" v-show="dorm.big" @click.prevent="showTel" v-if="show">
          <span class="show-tel__icon">
            <svg-icon type="icon-phone" />
          </span>
          Telefona Bak
        </div>
        <div class="dorm-card__inf" v-if="dorm.branch_count > 0 && dorm.center_slug">
          <div class="icon-font">
            <svg-icon type="icon-branches"/>
          </div>
          <div class="btn-txt">
            {{ dorm.branch_count }} Şube
          </div>
        </div>
        <div class="dorm-card__inf" v-if="!dorm.branch_count || !dorm.center_slug">
          <div class="icon-font">
            <svg-icon type="icon-bed"/>
          </div>
          <div class="btn-txt">
            {{ getCapacity }} Yatak
          </div>
        </div>

        <div v-if="dorm.meal && !dorm.branch_count" class="dorm-card__inf" >
          <div class="icon-font">
            <svg-icon type="icon-food"/>
          </div>
          <div class="btn-txt">
            {{ dorm.meal }} Öğün
          </div>
        </div>
        <div v-else-if="!dorm.meal && !dorm.is_wifi && !dorm.branch_count " class="dorm-card__inf">
          <div class="icon-font">
            <svg-icon type="icon-food"/>
          </div>
          <div class="btn-txt" disabled>
            Yok
          </div>
        </div>
        <div v-else-if="!dorm.meal && dorm.is_wifi && !dorm.branch_count" class="dorm-card__inf">
          <div class="icon-font">
            <svg-icon type="icon-wifi"/>
          </div>
          <div class="btn-txt">
            Wifi Var
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'DormCard',
  data () {
    return {
      show: true,
      branchnumber: '',
      branchNames: '',
      distinctCities: ''
    }
  },
  props: {
    dorm: Object
  },
  methods: {
    getDistricts () {
    // const id = window.localStorage.getItem('branchedDormId')
      var self = this
      // const url = self.$attrs.redirect ? `/site/dorm/detail/old/${dormID}` : `/site/dorm/detail/${this.$route.params.id}`
      const url = `/site/dorm/branches/${this.dorm.id}`
      // let distinctArray = []
      /*               let district1 = {
               name: 'Tüm İlçeler',
               slug: 'tum-ilceler'
             }
       this.districts.push(district1) */

      axios.get(url)
        .then(response => {
          // this.isLoading = false
          // self.detail = response.data

          if (response.data.branches.length > 1) {
            let distinctArray = [...new Set(response.data.branches.map(x => x.city.name))]
            distinctArray.forEach((data) => {
              self.distinctCities = self.distinctCities + data + ', '
              /*              let district = {
               name: data,
               slug: self.string_to_slug(data)
             } */
              // self.districts.push(district)
            })
            let ewStr = self.distinctCities.substring(0, self.distinctCities.length - 1)
            let ewStr2 = ewStr.substring(0, ewStr.length - 1)
            if (ewStr2.includes(', ')) {
              self.distinctCities = ewStr2 // ewStr.substring(0, ewStr.length - 1);
            } else {
              self.distinctCities = response.data.city.name + ' Şubeleri'
            }

            // window.localStorage.setItem('branchnumber', response.data.branches.length)
          }
        })
    },
    showTel () {
      this.show = false
    },
    openDorm () {
      window.localStorage.setItem('dormid', this.dorm.id)
      let url = 'http://www.yurtlarburada.com/' + this.dorm.slug + '-y-' + this.dorm.id
      window.localStorage.setItem('url', url)
      window.localStorage.setItem('description', this.dorm.description)
      window.localStorage.setItem('name', this.dorm.name)
      // window.localStorage.setItem('city', this.dorm.city.slug)

      if (this.dorm.branch_count > 0 && this.dorm.center_slug) {
        // const url = self.$attrs.redirect ? `/site/dorm/detail/old/${dormID}` : `/site/dorm/detail/${this.$route.params.id}`
        window.localStorage.setItem('branchedDormTitle', this.dorm.center_name)
        window.localStorage.setItem('branchDescription', this.dorm.description)
        window.localStorage.setItem('branchKeywords', this.dorm.keywords)
        window.localStorage.setItem('branchedDormId', this.dorm.id)

        if (this.dorm.logo) {
          window.localStorage.setItem('dormLogo', this.dorm.logo)
        }

        window.localStorage.setItem('dormWeb', this.dorm.web)
        window.localStorage.setItem('slug', this.dorm.center_slug)
        if (this.dorm.center_description) {
          window.localStorage.setItem('center_description', this.dorm.description)
          window.localStorage.setItem('center_keywords', this.dorm.keywords)
        }
        if (this.dorm.city) {
          window.localStorage.setItem('city', this.dorm.city.name)
        }
        // let dorm = this.string_to_slug(this.dorm.slug)
        let route = { name: 'BranchMain', params: { dorm: this.dorm.center_slug, id: this.dorm.id } }
        this.$router.push(route)
      } else {
        window.localStorage.setItem('slug', this.dorm.slug + '-y-' + this.dorm.id)
        if (this.$helpers.mobileCheck()) {
          window.open(window.location.origin + '/' + this.dorm.slug + '-y-' + this.dorm.id, '_self')
        } else {
          window.open(window.location.origin + '/' + this.dorm.slug + '-y-' + this.dorm.id, '_blank')
        }
      }
    }
  },
  computed: {
    getCapacity () {
      if (this.dorm && this.dorm.capacity) {
        return this.dorm.capacity.replace('kişi', '')
      } else {
        return ''
      }
    }
  },
  created () {
    if (this.dorm.branch_count > 0 && this.dorm.center_slug) {
      this.getDistricts()
    }
    if (!this.dorm.city) {
      this.dorm.city = {
        name: ''
      }
    }

    if (!this.dorm.district) {
      this.dorm.district = {
        name: ''
      }
    }
    // if(this.dorm.name.includes('Şişli Şube') || this.dorm.name.includes('Sinanpaşa')) {
    // }
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/components/dorm-card";
  .mywashed {
    background-blend-mode: lighten
  }
</style>
